<template>
  <div>
    <!--彈出視窗-->
    <v-dialog v-model="visible" persistent :max-width="width">
      <v-card>
        <v-card-title class="headline">
          {{ title }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12>
              <v-flex>
                <input ref="files"
                       type="file" :name="uploadFieldName"
                       @change="handleFilesUpload()"
                       accept="image/*,.xlsx,.xls,.csv,.pdf,.doc,.docx,.ppt,.pptx" hidden>
                <v-btn color="success" dark text @click="chooseFile">新增檔案</v-btn>

                <span v-if="files && files.length > 0"> {{ files.length > 0 ? files[0].name : '' }}</span>
                <span v-else-if="editedItem.fileName !== ''"> {{ editedItem.fileName }}</span>
<!--                <button type="button" class="btn-gray" style="margin-right: 10px;" @click="chooseFile"><span class="icon icon-add-d"></span>新增檔案</button>-->
              </v-flex>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>

            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12>
              <v-select :items="tags"
                        item-text="name"
                        item-value="name"
                        v-model="editedItem.category"
                        label="檔案類型"
              ></v-select>
<!--              <v-text-field-->
<!--                :label="`檔案類型`"-->
<!--                background-color="#49bcfd"-->
<!--                outline-->
<!--                v-model="editedItem.category"-->
<!--              ></v-text-field>-->
            </v-flex>
          </v-layout>

          <v-layout row wrap v-if="editedItem.url !==''">
            <v-flex>
              <v-text-field
                :label="`網址`"
                background-color="#49bcfd"
                outline
                v-model="editedItem.url"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex>
              <v-text-field
                :label="`備註`"
                background-color="#49bcfd"
                outline
                v-model="editedItem.comment"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn color="red" dark text v-if="!isNew" @click="deleteEvent">刪除</v-btn>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelEvent">取消</v-btn>
          <v-btn color="primary" dark text @click="confirmEvent">確定</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import MobileDetect from "mobile-detect";
import { mapActions } from "vuex";

const md = new MobileDetect(window.navigator.userAgent);

export default {
  name: "FileEditDialog",
  props: {
    visible: Boolean,
    title: String,
    item: Object,
    isNew: Boolean,
    tags: Array,
  },
  data() {
    return {
      width: md.phone() ? "80%" : "50%",
      type: 0,
      menu: false,
      fileList:[],
      uploadFieldName: 'files',
      files: [],
    };
  },
  created() {
  },
  computed: {
    editedItem() {
      return this.item;
    },
  },
  watch: {
    visible(value) {
      console.log(`file visible = ${value}`)
    }
  },
  methods: {
    ...mapActions([
      "getProductId",
    ]),
    chooseFile(){
      this.$refs.files.click();
    },
    handleFilesUpload() {
      console.log('handleFilesUpload');


      this.files = Array.from(this.$refs.files.files);
      console.log(this.files);
      // this.files = this.$refs.files.files;
    },
    confirmEvent() {
      this.$emit("confirmEvent", { item: this.editedItem, files: this.files });
    },
    cancelEvent() {
      this.$emit("cancelEvent");
    },
    deleteEvent(){
      this.$emit("deleteEvent", this.editedItem.fileId);
    }
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/FileEditDialog.vue